import Fulllayout from '../layouts/fulllayout.js';
import Maintenance from '../views/maintenance/Maintenance.js';
var routes = [
    { path: '/maintenance', name: 'maintenance', component: Maintenance },
    { path: '/', name: 'home', component: Fulllayout },
];

export default routes;
